/**
 * Hero banner background video
 * Clears the low-resolution default poster once playback starts.
 */
export class HeroBanner extends HTMLElement {
  constructor() {
    super();
    this.onPlaying = this.onPlaying.bind(this);
    this.onCanPlay = this.onCanPlay.bind(this);
  }

  connectedCallback() {
    this.initVideo();
  }

  disconnectedCallback() {
    const video = this.video;
    if (!video) return;

    video.removeEventListener('playing', this.onPlaying);
    video.removeEventListener('canplay', this.onCanPlay);
    this.video = null;
    this.wrap = null;
  }

  initVideo() {
    this.wrap = this.querySelector('[data-hero-video-wrap]');
    this.video = this.wrap?.querySelector('video');

    if (!this.video) {
      return;
    }

    this.video.addEventListener('playing', this.onPlaying, { once: true });

    if (this.video.readyState >= 2) {
      this.onPlaying();
      return;
    }

    this.video.addEventListener('canplay', this.onCanPlay, { once: true });
  }

  onPlaying() {
    if (!this.video) return;

    this.video.removeAttribute('poster');
    this.video.classList.add('is-playing');
    this.wrap?.classList.add('is-playing');
  }

  onCanPlay() {
    if (!this.video) return;

    const playPromise = this.video.play();
    if (playPromise?.catch) {
      playPromise.catch(() => {});
    }
  }
}

if (!customElements.get('hero-banner')) {
  customElements.define('hero-banner', HeroBanner);
}
